exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#accountCreationDisclosures .sprk-b-Link{border-bottom:none;color:#3333de;font-weight:400;text-decoration:underline;text-decoration-skip-ink:auto;text-underline-position:from-font;transition:none}#accountCreationDisclosures .sprk-b-Link:hover,#accountCreationDisclosures .sprk-b-Link:focus,#accountCreationDisclosures .sprk-b-Link:active{border-bottom:none;color:#3333de;text-decoration:none}#accountCreationDisclosures .sprk-b-Link:focus{outline:none}#accountCreationDisclosures .sprk-b-Link:focus-visible{border-radius:4px;outline:3px solid #3333de;outline-offset:3px}", ""]);

// exports
